import { Component, ViewChild, ElementRef, AfterViewChecked, Output, EventEmitter, Renderer2, HostListener } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FunctionsService } from 'src/app/data/functions.service';
import { AdicionaNegociacaoCompostaComponent } from "../adiciona-negociacao-composta/adiciona-negociacao-composta.component";
@Component({
  selector: 'app-fullscreen-modal-contextual-search',
  templateUrl: './fullscreen-modal-contextual-search.component.html',
  styleUrls: ['./fullscreen-modal-contextual-search.component.css'],
})
export class FullscreenModalContextualSearchComponent {
  defaultImage = './assets/images/watch.svg';
  messages: {
    type: 'text' | 'products', text?: string, sender: 'user' | 'responder', products?: {
      id: string;
      ean: string;
      nome: string;
      imagem?: { url: string };
      negociacoes_ativas: number;
      selected: boolean;
      rating?: number;
    }[]
  }[] = [];
  newMessage: string = '';
  afterSearched: boolean = false;
  isOpen = true;
  selectedProducts: any[] = [];
  @ViewChild('messageHistory') messageHistory!: ElementRef<HTMLDivElement>;
  @Output() closed = new EventEmitter<void>();
  showNegotiationModal: boolean = false; // Start as false, toggle on demand
  productsToNegotiate: { ean: string, nome: string, imagemUrl?: string, prompt_id: number, }[] = [];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<FullscreenModalContextualSearchComponent>,
    private functions: FunctionsService,
    private router: Router,
    private renderer: Renderer2,
  ) {
  }

  sendMessage(): void {
    if (this.newMessage.trim()) {
      this.messages.push({ type: 'text', text: this.newMessage.trim(), sender: 'user' });
      this.functions.contextualSearch(this.newMessage.trim()).subscribe({
        next: async (response) => {
          const { produtos: productsResponse, prompt_id } = response.data;
          const products: { id: string; ean: string; nome: string; imagem?: { url: string }; negociacoes_ativas: number; selected: boolean; rating: number; prompt_id: number; }[] = [];
          await Promise.all(productsResponse.map(e =>
            this.functions.searchOneByTerm({ nome: e, top: 1, skip: 1, }).subscribe({
              next: (response) => {
                const { produtos } = response.body.data;
                console.trace(e, produtos[0],)
                if (produtos.length > 0)
                  products.push({ ...produtos[0] as { id: string; nome: string; imagem: { url: string }; negociacoes_ativas: number; rating: number; ean: string; prompt_id: number }, selected: true, prompt_id });
                this.afterSearched = true;
              },
              error: (err) => console.log(err)
            })
          ));
          this.messages.push({ type: 'products', sender: 'responder', products });
        },
        error: (err) => {
          console.error('Error in contextual search:', err);
        }
      });
      this.newMessage = '';
      setTimeout(() => this.scrollToBottom(), 0);
    }
  }

  onCheckboxChange(produto: any): void {
    if (produto.selected) {
      this.selectedProducts.push(produto);
    } else {
      this.selectedProducts = this.selectedProducts.filter(p => p.id !== produto.id);
    }
    console.log('Selected products:', this.selectedProducts);
  }

  private scrollToBottom(): void {
    if (this?.messageHistory && this.messageHistory?.nativeElement) {
      this.messageHistory.nativeElement.scrollTop = this.messageHistory.nativeElement.scrollHeight;
    }
  }

  closeModal(): void {
    this.isOpen = false;
    this.closed.emit();
    this.dialogRef.close();
  }

  @HostListener('document:keydown.enter', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    this.sendMessage();
  }

  avaliacoes(produto: any) {
    console.trace('Avaliação do produto', produto);
  }

  queroComprar(products: any) {
    console.log('Products to negotiate:', products); // Debug the input
    if (products) {
      this.productsToNegotiate = products.filter(f => f.selected).map(p => ({
        ean: p.ean,
        nome: p.nome,
        imagemUrl: p.imagem?.url || this.defaultImage,
        ...p,
      }));
      this.showNegotiationModal = true;
      console.log('showNegotiationModal set to true, productsToNegotiate:', this.productsToNegotiate); // Debug
    } else {
      console.warn('No products provided to queroComprar');
    }
  }

  onNegotiationModalClosed() {
    this.showNegotiationModal = false;
    this.productsToNegotiate = [];
    console.log('Negotiation modal closed'); // Debug
  }
}
